/**
 * The AI Service detail page's Interface tab (task 800).
 *
 * Promoted out of Connect unchanged. The generated interface — the form a team
 * actually uses — was the first section inside a tab it shared with API call
 * snippets, which put a first-class building activity behind a label about
 * consumption and left it competing with a different audience's content. It is
 * now the whole tab, and the tab is the interface builder's home as that feature
 * grows.
 *
 * The section itself is untouched: preview sandbox, version picker, the
 * empty-state route into the Composer flow, and the copy link all still come
 * from `ServiceInterfaceSection`.
 *
 * The hosted-interface example that followed it until task 811 now lives in the
 * **Developer Info** tab's UI section. Hosting a copied-out interface on your
 * own site is an integration question — it is asked by the developer who has to
 * do it, alongside the interface's URL and the self-hosting story — whereas this
 * tab is where the interface gets BUILT.
 */
import type { Endpoint } from '@/types';
import { ServiceInterfaceSection } from './ServiceInterfaceSection';
import { ServiceInterfacePublishingSection } from './ServiceInterfacePublishingSection';

interface ServiceInterfaceTabProps {
  endpoint: Endpoint;
}

export function ServiceInterfaceTab({ endpoint }: ServiceInterfaceTabProps) {
  return (
    <div className="space-y-6" data-testid="service-interface-tab">
      <ServiceInterfaceSection endpointId={endpoint.id} endpoint={endpoint} />

      {/* Publishing (task 850) — BELOW the builder, because publishing is a
          decision about something that already exists. It reads the same
          version list the section above renders, so the version a reader is
          looking at and the version they can publish are never two lists. */}
      <ServiceInterfacePublishingSection endpoint={endpoint} />
    </div>
  );
}

export default ServiceInterfaceTab;
